import { IconButton } from '../../../actions/iconButton/IconButton'
import { RawRadioGroup } from '../../../forms/radioGroup/RawRadioGroup'
import { useTranslate } from '../../../hooks'
import { Dropdown } from '../../../structure/dropdown/Dropdown'
import type { ColumnFilterState } from '../useFilterState'

type State<T> = ColumnFilterState<T> & { type: 'radio' }

type Props<T> = {
  state: State<T>
  onStateChanged: (state: State<T>) => void
}

export const RadioFilter = <T,>({ state, onStateChanged }: Props<T>) => {
  const translate = useTranslate()

  return (
    <Dropdown
      element={
        <IconButton
          tip={translate('filter')}
          iconName="Filter"
          isSelected={state.selected !== state.options[0].label}
          className="-m-1"
        />
      }
      items={[
        {
          element: (
            <RawRadioGroup
              options={state.options.map(({ label }) => label)}
              renderFn={(label) => label}
              keyFn={(label) => label}
              value={state.selected}
              onChange={(selected) => onStateChanged({ ...state, selected })}
            />
          ),
        },
      ]}
    />
  )
}
